import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import CompareArrowsOutlinedIcon from '@mui/icons-material/CompareArrowsOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import { NavigationItem } from '.';

const ownerNavItems: NavigationItem[] = [
  {
    text: 'Dashboard',
    route: '/dashboard',
    icon: <DashboardOutlinedIcon />,
  },
  {
    text: 'Balance Sheet',
    route: '/balance-sheet',
    icon: <AccountBalanceOutlinedIcon />,
  },
  {
    text: 'Accounts',
    route: '/accounts',
    icon: <PaidOutlinedIcon />,
  },
  {
    text: 'Transactions',
    icon: <CompareArrowsOutlinedIcon />,
  },
  {
    text: 'Documents',
    route: '/documents',
    icon: <DescriptionOutlinedIcon />,
    children: [
      { text: 'Document Vault', route: '/documents/document-vault' },
      { text: 'Reports' },
    ],
  },
  {
    text: 'Financial Team',
    route: '/team',
    icon: <GroupOutlinedIcon />,
  },
];

export default ownerNavItems;
